<template>
  <div class="netcall">
    <div class="net-box">
      <div class="main">
        <div class="header">
          <div class="back" @click="goBack()">
            <i class="el-icon-back back-icon"></i>
            视频问诊
          </div>
          <!-- <div class="title">与{{ target }}视频聊天</div> -->
          <div class="title">与患者视频聊天</div>
        </div>
        <div class="content">
          <div class="left win" id="local">
            <div class="username" v-if="isVideoActive">
              医生：{{ username }}
            </div>
          </div>
          <div class="right win" id="remote">
            <div class="tip_warpper" v-if="isCallStatus">
              <div class="tip">等待对方接听</div>
              <el-button
                style="width: 120px"
                type="danger"
                @click="cancelCall()"
                round
                >取消</el-button
              >
            </div>
            <div class="tip_warpper" v-if="isError">
              <div class="tip">{{ tip }}</div>
            </div>
            <div class="tip_warpper" v-if="isShowTargetName">
              <div class="tip">用户关闭摄像头</div>
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="footer-content">
            <div class="btn_warpper">
              <img
                class="mic btn"
                @click="micHandle()"
                :src="
                  require(`../../assets/images/mic_${
                    isMicActive ? 'j' : 'm'
                  }.png`)
                "
              />
            </div>
            <img
              class="out"
              @click="stopVideo()"
              src="../../assets/images/close_r.png"
            />
            <!-- <div class="invite" @click="inviteHandle()" v-else>邀请</div> -->
            <div class="btn_warpper">
              <img
                class="video btn"
                @click="videoHandle()"
                :src="
                  require(`../../assets/images/video_${
                    isVideoActive ? 'k' : 'g'
                  }.png`)
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import util from "@/utils";
import { updateVideoStatus } from "@/api/doctor.js";
import config from "@/config/config.js";
const statusMap = {
  10404: "频道不存在",
  10406: "加入房间错误",
  10407: "已经在频道内",
  10408: "邀请不存在或已过期",
  10409: "邀请已经拒绝",
  10410: "邀请已经接受",
  10417: "频道成员信息错误",
  10419: "频道人数超限",
  10201: "对方不在线",
  10202: "对方不在线",
  10420: "该账号，在其他端已经登录，并且已经在频道内",
};
const listenStatusMap = {
  CANCEL_INVITE: "通话已取消",
  REJECT: "对方拒绝视频通话",
  ACCEPT: "对方已接受",
  ROOM_JOIN: "对方加入房间",
  ROOM_CLOSE: "房间关闭",
  LEAVE: "对方已离开房间",
};
export default {
  data() {
    return {
      isMicActive: false,
      isVideoActive: false,
      channelName: "",
      target: "",
      uid: "",
      account: "",
      callTimer: "",
      audio: "",
      isCallStatus: false,
      isInvited: false,
      device: "",
      tip: "",
      isError: false,
      // countTimer: "",
      seconds: 30,
      username: "",
      channelId: "",
      isShowTargetName: false,
    };
  },
  computed: {
    roomListenType() {
      return this.$store.state.roomListenData.eventType;
    },
    roomListenData() {
      return this.$store.state.roomListenData;
    },
    isUserLeave() {
      return this.$store.state.isUserLeave;
    },
    isRemoteCloseVideo() {
      return this.$store.state.isRemoteCloseVideo;
    },
  },
  watch: {
    roomListenType(val, oldVal) {
      console.log(val);
      if (!val) return;
      if (val === "INVITE") {
        this.isCallStatus = true;
        // const isSupport = await util.checkBrowser();
        // if (!isSupport) return;
      } else if (val === "ACCEPT") {
        // clearInterval(this.countTimer);
        this.seconds = 0;
      } else if (val === "REJECT" || val === "LEAVE") {
        this.isCallStatus = false;
        this.$message(listenStatusMap[val]);
        setTimeout(() => {
          this.goBack();
        }, 500);
      } else if (val === "ROOM_JOIN") {
        this.isCallStatus = false;
        this.isError = false;
        this.isShowTargetName = false;
        this.tip = "";
      } else {
        this.isCallStatus = false;
        this.$message(listenStatusMap[val]);
      }
    },
    isUserLeave(val, oldVal) {
      if (val) {
        this.isCallStatus = false;
        this.isError = true;
        this.isShowTargetName = false;
        this.tip = `用户已挂断`;
        this.$message.warning("用户已挂断");
        this.$router.go(-1);
        this.closeVideo();
      }
    },
    isRemoteCloseVideo(val, oldVal) {
      if (val) {
        this.isError = false;
        this.isCallStatus = false;
        this.isShowTargetName = true;
      }
    },
  },
  created() {
    this.getMedia();
    this.setData();
    this.setDevice();
    const { client } = this.$store.state;
    if (client) {
      this.joinRoomHandle();
    } else {
      this.$store.dispatch("initWebRtc").then(async (res) => {
        // const isSupport = await util.checkBrowser();
        // if (!isSupport) return;
        this.joinRoomHandle();
      });
    }
  },
  methods: {
    async getMedia(){
        if(navigator.mediaDevices && navigator.mediaDevices.getUserMedia){
          // 请求访问相机设备
          const that = this;
          navigator.mediaDevices.getUserMedia({ video: true })
            .then(function(stream) {
              // 相机访问成功，做后续操作
            })
            .catch(function(error) {
              if (error.name === 'NotAllowedError' || error.name === 'NotFoundError') {
                // 用户未授权相机访问或者没有可用设备
                that.$alert('请再浏览器地址栏右侧允许访问相机并确保设备已连接', '温馨提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              } else {
                // 其他错误
                console.log('启动相机时出错：' + error.message);
              }
            });
        }else{
          this.$message.warning("请再浏览器地址栏右侧允许访问相机并确保设备已连接");
        }
    },
    setData() {
      this.channelName = this.$route.query.channelName;
      this.target = this.$route.query.target || "";
      this.uid = this.$route.query.uid;
      this.account = this.$route.query.account;
      this.isInvited = this.$route.query.isInvited;
      this.device = this.$route.query.device;
      this.username = util.getStore("username");
    },
    closeVideo() {
      this.updateVideoStatus();
      // clearInterval(this.countTimer);
      this.cancelCall(true);
      this.$store.dispatch("setListenRoomData", "");
      this.$store.dispatch("leave");
      this.$store.dispatch("resetRoom");
      this.leaveSingLing();
    },
    async updateVideoStatus() {
      await updateVideoStatus();
    },
    goBack() {
      this.$router.go(-1);
      this.closeVideo();
    },
    setDevice() {
      const { device } = this;
      if (device.indexOf(1) === -1) {
        this.isVideoActive = true;
      }
      if (device.indexOf(2) === -1) {
        this.isMicActive = true;
      }
    },
    stopVideo() {
      this.$alert("请确认是否退出视频聊天问诊", "温馨提示", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action === "confirm") {
            this.$router.go(-1);
            this.closeVideo();
          }
        },
      });
    },
    joinRoomHandle() {
      const { channelName } = this.$route.query;
      this.$store
        .dispatch("joinRoom", {
          channelName,
          device: this.device,
          uid: this.uid,
        })
        .then((res) => {
          console.log("加入房间成功", res);
          if (this.isInvited === "1") return;
          const nim = this.$store.state.nim;
          if (nim) {
            this.creatSingLing();
          } else {
            let loginInfo = {
              uid: cookie.readCookie("uid"),
              sdktoken: cookie.readCookie("sdktoken"),
            };
            this.$store.dispatch("initNimSDK", loginInfo).then((res) => {
              this.creatSingLing();
            });
          }
        })
        .catch((error) => {
          console.log("error:", error);
        });
    },
    lingStop() {
      const audio = this.audio;
      audio && audio.pause();
      this.audio = "";
      clearInterval(this.callTimer);
    },
    lingPlay() {
      this.audio = new Audio();
      this.audio.src = require("../../assets/begg.mp3");
      this.callTimer = setInterval(() => {
        this.audio &&
          this.audio
            .play()
            .then(() => {
              console.log("播放成功");
            })
            .catch(() => {
              this.$message.error("音频设备未允许，请在设置中心允许播放音频");
              clearInterval(this.callTimer);
            });
      }, 1000);
    },
    micHandle() {
      const { device } = this;
      const isOpen = device.indexOf(1) !== -1 && device.indexOf(2) !== -1;
      this.$store
        .dispatch("setOrRelieveSilence", {
          status: !this.isMicActive,
          isOpen,
        })
        .then((res) => {
          this.isMicActive = !this.isMicActive;
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },
    videoHandle() {
      const { device } = this;
      const isOpen = device.indexOf(1) !== -1 && device.indexOf(2) !== -1;
      this.$store
        .dispatch("stopOrOpenVideo", {
          status: !this.isVideoActive,
          isOpen,
        })
        .then(() => {
          this.isVideoActive = !this.isVideoActive;
        })
        .catch((err) => {
          console.log("err:", err);
        });
    },
    leaveSingLing() {
      if (!this.channelId) return;
      this.$store
        .dispatch("leaveSignaLing", {
          channelId: this.channelId,
          channelName: this.channelId,
        })
        .then((res) => {
          console.log("退出成功", res);
        })
        .catch((err) => {
          console.log("退出失败", err);
        });
    },
    creatSingLing() {
      const { channelName } = this.$route.query;
      this.$store
        // .dispatch("createSingLing", channelName)
        .dispatch("createSingLing", channelName)
        .then((res) => {
          this.joinSingLingHandle(res);
        })
        .catch((err) => {
          console.log("-===", err);
          if (err.code == 10405) {
            this.$store
              // .dispatch("queryChannelInfo", channelName)
              .dispatch("queryChannelInfo", channelName)
              .then((info) => {
                console.log("channelId:", info);
                this.joinSingLingHandle(info);
              });
          }
        });
    },
    joinSingLingHandle(info) {
      const { channelId } = info;
      this.channelId = channelId;
      this.$store
        .dispatch("joinSingLing", {
          channelId,
          uid: this.uid,
        })
        .then((res) => {
          this.inviteSelfHandle();
        })
        .catch((err) => {
          console.log(channelId, this.uid);
          console.log("err", err);
          this.$message.error(statusMap[err.code]);
          if (err.code === 10407) {
            this.inviteSelfHandle();
          }
        });
    },
    inviteSelfHandle() {
      const { channelName } = this.$route.query;
      this.$store.dispatch("queryChannelInfo", channelName).then((info) => {
        console.log(info);
        const { channelId } = info;
        this.$store
          .dispatch("inviteSingLing", {
            channelId,
            requestId: this.uid,
            account: this.account,
            attachExt: this.$route.query.treatId,
          })
          .then((res) => {
            this.isCallStatus = true;
            this.isTip = false;
            // this.countDown();
          })
          .catch((error) => {
            this.tip = statusMap[error.code];
            this.isCallStatus = false;
            this.isError = true;
            this.isShowTargetName = false;
          });
      });
    },
    inviteHandle() {
      this.isError = false;
      this.isCallStatus = true;
      this.isShowTargetName = false;
      this.inviteSelfHandle();
    },
    cancelCall(isLeave = false) {
      console.log("取消");
      if (!this.channelId) return;
      const { channelName, channelId } = this;
      const params = {
        channelId: channelId,
        account: this.account,
        channelName: channelName,
        requestId: this.uid,
      };
      this.$store
        .dispatch("cancelInvite", params)
        .then((res) => {
          this.isCallStatus = false;
          this.isError = true;
          this.isShowTargetName = false;
          this.tip = "对方未接听";
          this.seconds = 60;
        })
        .catch((error) => {
          console.log("取消失败");
          !isLeave && this.$message.error(statusMap[error.code]);
        });
    },
    countDown() {
      this.countTimer = setInterval(() => {
        if (this.seconds > 0 && this.seconds <= 60) {
          console.log(this.seconds);
          this.seconds--;
        } else {
          clearInterval(this.countTimer);
          this.seconds = 5;
          this.cancelCall();
          this.isError = true;
          this.isShowTargetName = false;
          this.isCallStatus = false;
          this.tip = "对方未接听";
        }
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.netcall {
  height: 100vh;
  padding: 12px;
  .net-box {
    height: 100%;
  }
  .main {
    .header {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background: #25252d;
      margin-bottom: 10px;
      position: relative;
      height: 45px;
      .back {
        position: absolute;
        left: 10px;
        cursor: pointer;
      }
    }
    height: 100%;
    display: flex;
    flex-direction: column;
    background-image: linear-gradient(179deg, #141417, #181824);
    .content {
      flex: 1;
      display: flex;
      align-items: flex-start;
      padding: 0 20px;
      .win {
        flex: 1;
        height: 100%;
        background: #25252d;
        & + .win {
          margin-left: 20px;
        }
      }
      .username {
        height: 100%;
        color: #fff;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .right {
        position: relative;
        .tip_warpper {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #fff;
          .tip {
            margin-bottom: 10px;
          }
        }
      }
    }
    .footer {
      height: 75px;
      width: 100%;
      display: flex;
      align-items: center;
      .footer-content {
        width: 40%;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        .btn_warpper {
          flex: 1;
          text-align: center;
          .btn {
            width: 60px;
            height: 54px;
          }
        }

        .out {
          width: 70px;
        }
        .invite {
          color: #fff;
          background: #008000;
          width: 100px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>
